module.exports = __webpack_public_path__ + "media/16/left-arrow-9c5c8cb3.svg";